import { IApiSuccessWrapper, IRegion } from '$/types'
import { apiSlice } from '.'

export interface IGetSystemScopeRegionsParams {
  operatorCodes?: string[]
  stateCodes?: string[]
}

export const systemScopeRegionsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getRegions: build.query<IRegion[], IGetSystemScopeRegionsParams>({
      query: ({ operatorCodes, stateCodes }) => ({
        method: 'GET',
        url: '/regions',
        params: {
          // Only include parameters in query string if provided
          ...(operatorCodes != null &&
            operatorCodes.length > 0 && { operatorCode: operatorCodes }),
          ...(stateCodes != null &&
            stateCodes.length > 0 && { stateCode: stateCodes })
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IRegion[]
      }
    })
  })
})

export const { useGetRegionsQuery } = systemScopeRegionsApi
